<template>
  <div class="chart-bar">
    <div class="chart-card">
      <div class="card-item-inner l2-1">
        <div class="group_10 flex-col">
          <div class="box_12 flex-row">
            <div class="block_6 flex-col">
              <div class="image-wrapper_1 flex-col">
                <img
                    class="thumbnail_4"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/63add2ec62a769bd988ff30f8f7d8971"
                />
              </div>
              <span class="text_94">基础信息</span>
            </div>
            <div class="block_7 flex-row">
              <span class="text_95">执常委</span>
              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/3185f6e1e81cd4cf243c98b6ad10ec8b"
              />
            </div>
            <div class="block_8 flex-col justify-between">
              <div class="group_11 flex-row justify-between">
                <img
                    class="thumbnail_6"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/02aff6b5edd8e22f92a2b6ac3751ecdf"
                />
                <span class="text_96">请输入执常委姓名</span>
              </div>
              <div class="group_12 flex-col"></div>
            </div>
            <div class="block_9 flex-col justify-between">
              <div class="block_10 flex-row justify-between">
                <img
                    class="label_4"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/a94f497ff71ede46beb47662ba87d621"
                />
                <span class="text_97">企业荣誉</span>
              </div>
              <img
                  class="image_9"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/641039543b39371faea1d307e10fdcad"
              />
            </div>
          </div>
          <div class="box_13 flex-row">
            <div class="group_13 flex-col">
              <div class="block_11 flex-col">
                <div class="group_14 flex-row">
                  <div class="box_14 flex-col"></div>
                  <div class="text-wrapper_18 flex-col justify-between">
                    <span class="text_98">姓名:</span>
                    <span class="text_99">性别:</span>
                  </div>
                  <div class="text-wrapper_19 flex-col">
                    <span class="text_100">详情&gt;</span>
                    <span class="text_101">陈志列</span>
                    <span class="text_102">男</span>
                  </div>
                </div>
                <div class="text-wrapper_20 flex-row">
                  <span class="text_103">年龄:</span>
                  <span class="text_104">62岁</span>
                  <span class="text_105">学历:</span>
                  <span class="text_106">研究生</span>
                </div>
                <div class="text-wrapper_21 flex-row">
                  <span class="text_107">性别:</span>
                  <span class="text_108">男</span>
                  <span class="text_109">工商联职务:</span>
                  <span class="text_110">主席</span>
                </div>
              </div>
              <div class="image-wrapper_2 flex-col">
                <img
                    class="image_10"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/2564c68afcd591de0c9bb8dbf5783270"
                />
              </div>
              <div class="block_12 flex-col">
                <span class="text_111">详情&gt;</span>
                <span class="text_112">企业名称</span>
                <span class="text_113">研祥高科技控股集团有限公司</span>
                <span class="text_114">法人代表</span>
                <span class="text_115">陈志列</span>
                <span class="text_116">行业代码</span>
                <span class="text_117">信息传输、软件和信息技术服务业</span>
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_118">企业健康监测</span>
                  <span class="text_119">健康</span>
                </div>
              </div>
              <span class="text_120">关联企业</span>
            </div>
            <div class="group_15 flex-col">
              <div class="box_47 flex-col">
                <span class="text_138">向北京丘成桐科学基金会</span>
                <span class="text_139">开展乡村产业振兴</span>
                <div class="text-wrapper_32 flex-col">
                  <span class="text_140">向深圳市慈善会捐款50万元支持</span>
                  <span class="text_141">开展乡村产业振兴</span>
                </div>
              </div>
              <div class="text-wrapper_33 flex-col">
                <span class="text_142">广西壮族自治区马山县实地</span>
                <span class="text_143">走访调研2次</span>
              </div>
              <div class="text-wrapper_34 flex-col">
                <span class="text_144">广西壮族自治区马山县实地</span>
                <span class="text_145">走访调研2次</span>
              </div>
              <div class="text-wrapper_35 flex-col">
                <span class="text_146">支持农村春节疫情防控购买</span>
                <span class="text_147">制氧机捐款500万</span>
              </div>
              <div class="box_15 flex-col">
                <span class="text_121">参加中国光彩事业西藏行</span>
                <div class="image-wrapper_3 flex-col">
                  <img
                      class="image_11"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/c3c957ce5d1a22c9822576d8f56e2dcb"
                  />
                </div>
              </div>
              <div class="box_16 flex-col">
                <div class="text-wrapper_22 flex-col">
                  <span class="text_122">向深圳市慈善会捐款50万元支持</span>
                  <span class="text_123">开展乡村产业振兴</span>
                </div>
                <div class="text-wrapper_23 flex-col">
                  <span class="text_124">参加中国光彩事业西藏行</span>
                </div>
                <div class="image-wrapper_4 flex-col">
                  <img
                      class="image_12"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/8413b6c51f0fc0765742aa2744604ea8"
                  />
                </div>
                <div class="image-wrapper_5 flex-col">
                  <img
                      class="image_13"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/59c304eafcb81479f80338fd14435952"
                  />
                </div>
              </div>
              <div class="image-wrapper_6 flex-row justify-between">
                <img
                    class="image_14"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/4f20e77faa28077cd5076d53bece7469"
                />
                <img
                    class="image_15"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/19ed92c01b93f2d882d494168fb3d7ac"
                />
              </div>
              <div class="box_17 flex-row justify-between">
                <div class="box_18 flex-col">
                  <div class="box_19 flex-col">
                    <div class="box_20 flex-row justify-between">
                      <div class="section_9 flex-col"></div>
                      <div class="section_10 flex-col"></div>
                      <div class="section_11 flex-col"></div>
                    </div>
                    <div class="text-wrapper_24 flex-row">
                      <span class="text_125">企业家全国人大代表</span>
                    </div>
                  </div>
                  <div class="box_21 flex-col">
                    <div class="section_12 flex-row justify-between">
                      <div class="group_16 flex-col"></div>
                      <div class="group_17 flex-col"></div>
                      <div class="group_18 flex-col"></div>
                    </div>
                    <div class="text-wrapper_25 flex-row">
                      <span class="text_126">广东省工商联主席</span>
                    </div>
                  </div>
                  <div class="box_22 flex-col">
                    <div class="group_19 flex-row justify-between">
                      <div class="section_13 flex-col"></div>
                      <div class="section_14 flex-col"></div>
                      <div class="section_15 flex-col"></div>
                    </div>
                    <div class="text-wrapper_26 flex-row">
                      <span class="text_127">广东省总商会会长</span>
                    </div>
                  </div>
                  <div class="box_23 flex-col">
                    <div class="group_20 flex-row justify-between">
                      <div class="section_16 flex-col"></div>
                      <div class="section_17 flex-col"></div>
                      <div class="section_18 flex-col"></div>
                    </div>
                    <div class="text-wrapper_27 flex-row">
                      <span class="text_128">全国工商联科技装备商会会长</span>
                    </div>
                  </div>
                </div>
                <div class="box_24 flex-col">
                  <div class="box_25 flex-col">
                    <div class="section_19 flex-row justify-between">
                      <div class="box_26 flex-col"></div>
                      <div class="box_27 flex-col"></div>
                      <div class="box_28 flex-col"></div>
                    </div>
                    <div class="text-wrapper_28 flex-row">
                        <span class="paragraph_2"
                        >提交题为关于加快推进国产操作系统<br />在工业领域适配建议</span
                        >
                    </div>
                  </div>
                  <div class="box_29 flex-col">
                    <div class="box_30 flex-row justify-between">
                      <div class="block_13 flex-col"></div>
                      <div class="block_14 flex-col"></div>
                      <div class="block_15 flex-col"></div>
                    </div>
                    <div class="text-wrapper_29 flex-row">
                        <span class="text_129"
                        >全国政协经济委专题座谈会上发言</span
                        >
                    </div>
                  </div>
                  <div class="box_31 flex-col">
                    <div class="section_20 flex-row justify-between">
                      <div class="group_21 flex-col"></div>
                      <div class="group_22 flex-col"></div>
                      <div class="group_23 flex-col"></div>
                    </div>
                    <div class="text-wrapper_30 flex-row">
                        <span class="text_130"
                        >参加最高法会议、调研活动5次</span
                        >
                    </div>
                  </div>
                  <div class="box_32 flex-col">
                    <div class="group_24 flex-row justify-between">
                      <div class="box_33 flex-col"></div>
                      <div class="box_34 flex-col"></div>
                      <div class="box_35 flex-col"></div>
                    </div>
                    <div class="text-wrapper_31 flex-row">
                        <span class="text_131"
                        >在最高法专题座谈会上发言4次</span
                        >
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_36 flex-row">
                <img
                    class="label_5"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/ef3db2c06b8ecea96f15a54da38519b9"
                />
                <span class="text_132">社会职务</span>
                <img
                    class="label_6"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/b5f14d13c38659bd928d7fef554a9d9d"
                />
                <span class="text_133">参政议政</span>
              </div>
            </div>
            <div class="group_25 flex-col">
              <div class="box_37 flex-col">
                <span class="text_134">中国企业500强</span>
                <img
                    class="image_16"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/09cecd9f5facdb3082944bd0265b1419"
                />
                <img
                    class="image_17"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/82b246897e299a246e521065acaeefa4"
                />
              </div>
              <div class="box_38 flex-col">
                <span class="text_135">中国制造企业500强</span>
                <img
                    class="image_18"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/b47012e77a73ccca6555251dbcc04e31"
                />
                <img
                    class="image_19"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/0478e4c60399c42411dd598a592b5261"
                />
              </div>
              <div class="box_39 flex-col">
                  <span class="paragraph_3"
                  >2023-2025年制造业单项<br />冠军示范企业</span
                  >
                <img
                    class="image_20"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/f79a6bbbf312b757e7a2e1591b4a958b"
                />
                <img
                    class="image_21"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/315d42fa1beb31e6dcb0959b58877d6b"
                />
              </div>
              <div class="box_40 flex-col">
                  <span class="paragraph_4"
                  >2023-2026全国工商联<br />科技创新民营企业</span
                  >
                <img
                    class="image_22"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/adaa7144932838878529ffbd9343181c"
                />
                <img
                    class="image_23"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/fb9a84ceea41feb85aaa26c20427c7f4"
                />
              </div>
              <div class="box_41 flex-col">
                  <span class="paragraph_5"
                  >2022年度中国民营<br />企业信用100强</span
                  >
                <img
                    class="image_24"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/cdd3fabd3571965e2531dd62adbdfcd4"
                />
                <img
                    class="image_25"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/3debc0fc46395d7dc751f31da834d63b"
                />
              </div>
              <div class="box_42 flex-col">
                  <span class="paragraph_6"
                  >2022年度中国民营制造<br />企业信用100强</span
                  >
                <img
                    class="image_26"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/30ccde39c3feeb1d31706f76eb6f6479"
                />
                <img
                    class="image_27"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/90a8464f7b3ccdbdfa077ecd64f1b4c3"
                />
              </div>
              <div class="box_43 flex-col">
                  <span class="paragraph_7"
                  >中国战略性新兴产业领军<br />企业100强</span
                  >
                <img
                    class="image_28"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/49e8684fdfcfb81c0d6e96334a150942"
                />
                <img
                    class="image_29"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/19aad8bf56d744d1000ee3df4e6f72da"
                />
              </div>
              <div class="box_44 flex-col">
                <span class="text_136">中国大企业创新100强</span>
                <img
                    class="image_30"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/ccc58ccfca12a82a8ad1c5ba55712b67"
                />
                <img
                    class="image_31"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/301cd6d25b66b3b912d4b069cebd383c"
                />
              </div>
              <div class="box_45 flex-col">
                  <span class="paragraph_8"
                  >2023年度优秀（政协）<br />委员工作站</span
                  >
                <img
                    class="image_32"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/5a6d259b99f5b0a54c7384c2fcbcc706"
                />
                <img
                    class="image_33"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/ab45722a113594f15255c2a5d40159a9"
                />
              </div>
              <div class="box_46 flex-col">
                <span class="text_137">全国质量诚信先进企业</span>
                <img
                    class="image_34"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/ebd57ce2171c88c552f2521de7f56dd9"
                />
                <img
                    class="image_35"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/9347ddc05dc4cce82ca115e70fba576d"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item l2-2">
        <div class="card-title">
          <div>广东省经济创新活力分析</div>
        </div>
        <div class="card-content">
          <div class="wrapper l3-2">
            <div class="top-box">
              <i></i>市场主体经营异常信息
              <b></b>
            </div>
            <div class="list-box">
              <div class="list-item">
                <div>经营异常</div>
                <b>155</b>
              </div>
              <div class="list-item">
                <div>变更登记</div>
                <b>944</b>
              </div>
              <div class="list-item">
                <div>涉企行政处罚</div>
                <b>469</b>
              </div>
              <div class="list-item">
                <div>互联网监管严重违法</div>
                <b>231</b>
              </div>
              <div class="list-item">
                <div>欠税</div>
                <b>15</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EleDialog title="企业名单" :visible.sync="showEntDialog" class="info-modal">
      <div class="filter-box">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          @change="
            (e) => {
              search.cityName = e;
              openModal(e);
            }
          "
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" clearable />
      </div>
      <ComTable
        :tableCol="tableColEnt"
        :tableData="tableDataEnt"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartScienceFunds';
import drawBar2 from '../chartJs/chartLicense';
import drawBar3 from '../chartJs/chartPrivateTaxes';
import FinancialService from './FinancialService.vue';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
export default {
  name: 'ChartBar',
  components: { ElementSelect, ComTable, TabList, MarketSubjectType, MarketMainIndustry, CompModal, FinancialService },
  props: {
    yearP: {
      type: Number,
      default: 2024,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      upIndex: 0, // 计算年份头
      downIndex: 0, // 计算年份头
      loading: true,
      loadingLine: true,
      chartOption: null,
      chartOption2: null,
      chartOption3: null,
      chartOption4: null,
      chartOptionLine: null,
      chartData: null,
      chartData2: null,
      chartData3: null,
      year: this.yearP,
      tabList: [
        {
          key: 0,
          label: '累计总数',
        },
        {
          key: 1,
          label: '本年新增',
        },
        {
          key: 2,
          label: '本年注销',
        },
      ],
      dataType: 1,
      dataTypeList: [
        {
          value: 1,
          label: '创新型中小企业',
        },
        {
          value: 2,
          label: '专精特新中小企业',
        },
        {
          value: 3,
          label: '专精特小巨人企业',
        },
        {
          value: 4,
          label: '上市民营企业',
        },
        {
          value: 5,
          label: '高新企业',
        },
      ],
      dataTypeYSLevel1: 2,
      dataTypeYS: [2],
      dataTypeYSList: [
        {
          value: 1,
          label: '明细指标评分',
          children: [],
        },
        {
          value: 2,
          label: '综合评分',
        },
      ],
      // [
      //   {
      //     value: '市场准入',
      //     label: '市场准入',
      //   },
      //   {
      //     value: '办理建筑许可',
      //     label: '办理建筑许可',
      //   },
      //   {
      //     value: '登记财产',
      //     label: '登记财产',
      //   },
      //   {
      //     value: '获得电力',
      //     label: '获得电力',
      //   },
      //   {
      //     value: '获得用水',
      //     label: '获得用水',
      //   },
      //   {
      //     value: '获得用气',
      //     label: '获得用气',
      //   },
      //   {
      //     value: '获得网络',
      //     label: '获得网络',
      //   },
      //   {
      //     value: '劳动力市场监管',
      //     label: '劳动力市场监管',
      //   },
      //   {
      //     value: '获得金融服务',
      //     label: '获得金融服务',
      //   },
      //   {
      //     value: '国际贸易',
      //     label: '国际贸易',
      //   },
      //   {
      //     value: '纳税',
      //     label: '纳税',
      //   },
      //   {
      //     value: '解决商业纠纷',
      //     label: '解决商业纠纷',
      //   },
      //   {
      //     value: '政府采购',
      //     label: '政府采购',
      //   },
      //   {
      //     value: '招标投标',
      //     label: '招标投标',
      //   },
      //   {
      //     value: '市场监管',
      //     label: '市场监管',
      //   },
      //   {
      //     value: '知识产权创造、运用和保护',
      //     label: '知识产权创造、运用和保护',
      //   },
      //   {
      //     value: '企业破产',
      //     label: '企业破产',
      //   },
      //   {
      //     value: '政务服务',
      //     label: '政务服务',
      //   },
      //   {
      //     value: '经营主体满意度',
      //     label: '经营主体满意度',
      //   },
      // ],
      ysYear: this.yearP,
      ysYearList: [],
      ysData: null, // 综合评分数据
      ysData1: [], // 明细指标评分数据
      mysjData: null,
      timer: null,
      timer2: null,
      startI: 0,
      startI2: 0,
      entData: {
        list: [],
        total: null,
      },
      statisData: null,
      tabIndex: 0,
      // yearP: null,
      options: [],
      showEntDialog: false,
      showCompany: false,
      search: {
        cityName: '佛山',
        enterpriseName: '',
      },
      optionCity: [
        // {
        //   value: '全省',
        //   label: '全省',
        // },
        ...cityJson,
      ],
      tableData: [],
      tableDataEnt: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      curData: null,
    };
  },
  created() {
    this.year = this.srYear = this.ysYear = new Date().getFullYear();
    this.options = [
      {
        value: this.year,
        label: this.year,
      },
    ];
    while (this.options.slice(-1)[0].value > 2021) {
      let tmp = this.options.slice(-1)[0];
      this.options.push({
        value: tmp.value - 1,
        lable: tmp.value - 1,
      });
    }
    this.srYearList = [
      {
        value: this.ysYear,
        label: this.ysYear,
      },
    ];
    this.ysYearList = [...this.srYearList];
  },
  computed: {
    tableColEnt() {
      return [
        {
          label: '序号',
          type: 'index',
          maxWidth: 70,
        },
        {
          label: '地市',
          param: 'city',
        },
        {
          label: '企业名称',
          param: 'entname',
          fn: (x) => {
            this.showEntDialog = false;
            this.curData = { ...x, companyName: x.entname };
            this.showCompany = true;
          },
        },
      ];
    },
  },
  watch: {
    year() {
      this.$nextTick(() => {});
    },
    'search.enterpriseName'(n) {
      if (!n) {
        this.search.enterpriseName = null;
      }
      this.pager.currentPage = 1;
      this.$nextTick(() => this.openModal());
    },
    showCompany(n) {
      if (!n) this.curData = null;
    },
    upIndex(n) {
      if (this.downIndex + n > 3) return;
      if (this.downIndex + n === 3) {
        if (n === 0) {
          this.options = this.options.filter((x) => x.value !== this.year);
          this.year = this.options[0].value;
        } else if (n !== 3) {
          this.year--;
        }
        this.getData();
      }
    },
    downIndex(n) {
      if (this.upIndex + n > 3) return;
      if (this.upIndex + n === 3) {
        if (n === 3) {
          this.options = this.options.filter((x) => x.value !== this.year);
          this.year = this.options[0].value;
        } else if (n !== 0) {
          this.year--;
        }
        this.getData();
      }
    },
  },
  methods: {
    handleLink(index) {
      this.$emit('handleLink', {
        index,
        dataType: this.dataType,
        year: this.year,
      });
    },
    getKC() {
      // 各市科创企业情况
      this.$api.market
        .getEntData({
          dataType: this.dataType,
          year: this.year,
        })
        .then((res) => {
          let { data } = res.data;
          this.entData = data;
          if (data.list.length) this.upIndex++;
          else this.downIndex++;
        });
    },
    getData() {
      this.$api.market.getYshjOption().then((res) => {
        let { firstLevel } = res.data.data;
        this.dataTypeYSList[0].children = firstLevel.map((x) => {
          for (const key in x) {
            if (Object.hasOwnProperty.call(x, key)) {
              const e = x[key];
              let second = e
                .filter((y) => y !== '/')
                .map((z) => ({
                  label: z,
                  value: z,
                }));
              return {
                label: key,
                value: key,
                children: second.length ? second : undefined,
              };
            }
          }
        });
      });
      this.getKC();
      // let chart = echarts.init(document.getElementById('bar-chart'));
      // 各市科技经费投入情况
      this.$api.market
        .getKjjfCity({
          year: this.year,
        })
        .then((res) => {
          let { data } = res.data;
          let listData = [];
          if (data && data.funds?.length) {
            this.upIndex++;
            data.funds.map((x) => {
              let t1 = x.city.replace(/\s+/g, '');
              let tmp = data.porportion.find((y) => {
                let t2 = y.city.replace(/\s+/g, '');
                let tmp2 = listData.find((z) => z.city === t1);
                return tmp2 ? false : t1 === t2;
              });
              if (tmp) listData.push({ porportion: tmp.proportion, city: t1, funds: x.funds });
            });
          } else this.downIndex++;
          let list = {
            yAxis: {
              names: ['单位：亿元', ''],
            },
            names: ['R&D经费', 'R&D经费占地区生产总值'],
            data: listData,
            grid: {
              top: '23%',
            },
            legend: {
              top: -5,
            },
          };
          this.chartData = list;
          this.updateChart();
          this.chartAuto();
          // this.chartOption = drawBar(list);
        });
      //各市专利授权情况
      this.$api.market
        .getZlsqCity({
          year: this.year,
        })
        .then((res) => {
          let { data } = res.data;
          let listData = [];
          if (data && data.invent?.length) {
            this.upIndex++;
            data.invent.map((x) => {
              let tmp = data.design.find((y) => y.city === x.city),
                tmp2 = data.utility.find((y) => y.city === x.city),
                tmp3 = listData.find((y) => y.city === x.city);
              if (!tmp3) {
                listData.push([x.city, x.invent, tmp2.utility, tmp.design]);
              }
            });
          } else this.downIndex++;
          let list = {
            yAxis: {
              names: ['单位：亿元', ''],
            },
            names: ['发明', '实用新型', '外观设计'],
            data: listData,
            isStack: true,
          };
          this.chartData2 = list;
          // this.chartOption2 = drawBar2(list);
          this.updateChart2();
          this.chartAuto2();
        });
      this.getYsList();
      // 广东省民营税金贡献
      this.$api.market
        .getSsgxDetail({
          endYear: this.yearP,
        })
        .then((res) => {
          let { data } = res.data.data;
          let list = {
            yAxis: {
              names: ['单位：亿元', '%'],
            },
            names: ['全省税收', '民营税收', '民营占比'],
            data,
          };
          this.chartData3 = list;
          this.chartOption3 = drawBar3(list);
        });
    },
    // 广东省“营商环境”评价
    getYsList() {
      if (this.dataTypeYSLevel1 === 1) {
        this.$api.market
          .getYshjCity({
            dataType: this.dataTypeYS,
            year: this.ysYear,
          })
          .then((res) => {
            let { data } = res.data.data;
            if (data.length) {
              this.ysData1 = data;
              this.getYsYList();
            } else {
              if (this.ysYear > 2021) {
                this.ysYear--;
                this.getYsList();
              }
            }
            // this.ysData = data.data.slice(0, 5);
          });
      } else {
        this.$api.market
          .getYshjData({
            year: this.ysYear,
          })
          .then((res) => {
            let { data } = res.data.data;
            if (data.length) {
              this.ysData = data;
              this.getYsYList();
            } else {
              if (this.ysYear > 2021) {
                this.ysYear--;
                this.getYsList();
              }
            }

            // this.ysData = data.data.slice(0, 5);
          });
      }
    },
    getYsYList() {
      if (this.ysYearList.length <= 1) {
        this.ysYearList = [
          {
            value: this.ysYear,
            lable: this.ysYear,
          },
        ];
        while (this.ysYearList.slice(-1)[0].value > 2021) {
          let tmp = this.ysYearList.slice(-1)[0];
          this.ysYearList.push({
            value: tmp.value - 1,
            lable: tmp.value - 1,
          });
        }
      }
    },
    getSrYList(e) {
      this.srYear = e;
      if (this.srYearList.length <= 1) {
        this.srYearList = [
          {
            value: this.srYear,
            lable: this.srYear,
          },
        ];
        while (this.srYearList.slice(-1)[0].value > 2021) {
          let tmp = this.srYearList.slice(-1)[0];
          this.srYearList.push({
            value: tmp.value - 1,
            lable: tmp.value - 1,
          });
        }
      }
    },
    chartAuto() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.startI = this.startI + 1 < this.chartData.data.length ? this.startI + 1 : 0;
        this.updateChart();
      }, 4100);
    },
    chartAuto2() {
      if (this.timer2) clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        this.startI2 = this.startI2 + 1 < this.chartData2.data.length ? this.startI2 + 1 : 0;
        this.updateChart2();
      }, 4100);
    },
    updateChart() {
      let max = this.chartData.data.length;
      let endI = this.startI + 9;
      let list = [];
      if (endI < max) {
        list = this.chartData.data.slice(this.startI, endI);
      } else
        list = [...this.chartData.data.slice(this.startI, max), ...this.chartData.data.slice(0, 9 - max + this.startI)];
      this.chartOption = drawBar({
        ...this.chartData,
        data: list,
      });
    },
    updateChart2() {
      let max = this.chartData2.data.length;
      let endI = this.startI2 + 9;
      let list = [];
      if (endI < max) {
        list = this.chartData2.data.slice(this.startI2, endI);
      } else
        list = [
          ...this.chartData2.data.slice(this.startI2, max),
          ...this.chartData2.data.slice(0, 9 - max + this.startI2),
        ];
      list.unshift(['invent', 'utility', 'design']);
      this.chartOption2 = drawBar2({
        ...this.chartData2,
        data: list,
      });
    },
    getEntList() {
      this.$api.market
        .getEntList({
          dataType: this.dataType,
          year: this.year,
          city: this.search.cityName,
          entName: this.search.enterpriseName,
          pageNum: this.pager.currentPage,
          pageSize: 10,
        })
        .then((res) => {
          this.tableDataEnt = [];
          this.tableDataEnt = res.data.data.records;
          this.pager.total = res.data.data.total;
        });
    },
    openModal(e) {
      this.showEntDialog = true;
      if (e) this.search.cityName = e;
      this.getEntList();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getEntList();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getEntList();
    },
  },
  mounted() {
    this.getData();
    this.getEntList();
  },
};
</script>

<style lang="less" scoped>
.box_15 {
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/c695b17e44715f380a734fef2cf8bea0)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 189px;
  width: 325px;
  position: relative;
}

.text_121 {
  width: 141px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 17px 0 0 102px;
}

.image-wrapper_3 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/98cbb47a25c3decac5893c31c77f4070) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -172px;
  top: 4px;
}

.image_11 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.text-wrapper_32 {
  position: absolute;
  left: -278px;
  top: 0;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ea8f102e075ca88cf106e7c207ed5e2e)
  100% no-repeat;
  background-size: 100% 100%;
}

.text_140 {
  width: 189px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 77px;
}

.text_141 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 11px 123px;
}

.text-wrapper_35 {
  position: absolute;
  left: 251px;
  top: 193px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/76c9b6163c7c219ce215221bd4b14ca2)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}

.text_146 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}

.text_147 {
  width: 94px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 3px 0 10px 47px;
}
.text-wrapper_34 {
  position: absolute;
  left: 251px;
  top: 130px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/a605f2cf9d740583581ebbca6b9106a8)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}

.text_144 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}

.text_145 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_33 {
  position: absolute;
  left: 286px;
  top: 68px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/aaaa44abff14d677c108bf81808690fb)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}

.text_142 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}

.text_143 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.block_11 {
  height: 220px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ab8bf6a51ea79e79dd20b824f1eaaaaf)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 218px;
}

.group_14 {
  width: 193px;
  height: 102px;
  margin: 15px 0 0 14px;
}

.box_14 {
  background-color: rgba(248, 250, 253, 1);
  width: 75px;
  height: 100px;
}

.text-wrapper_18 {
  width: 34px;
  height: 44px;
  margin: 58px 0 0 12px;
}

.text_98 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text_99 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 16px;
}

.text-wrapper_19 {
  width: 66px;
  height: 102px;
  margin-left: 6px;
}

.text_100 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 32px;
}

.text_101 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 44px;
}

.text_102 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 17px;
}

.text-wrapper_20 {
  width: 168px;
  height: 15px;
  margin: 18px 0 0 14px;
}

.text_103 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 1px;
}

.text_104 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}

.text_105 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 20px;
}

.text_106 {
  width: 41px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 6px;
}

.text-wrapper_21 {
  width: 189px;
  height: 15px;
  margin: 19px 0 36px 14px;
}

.text_107 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text_108 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}

.text_109 {
  width: 69px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 36px;
}

.text_110 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.ml12 {
  margin-left: 12px;
}
.chart-bar {
  .chart-box();
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
  .chart-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .card-item {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .left {
        display: flex;
         width: 27%;
        //width: 1024px;
        //padding-left: 32px;
      }
      .right {
        display: flex;
         width: 27%;
        //width: 1024px;
        //padding-left: 32px;
      }
      .center {
        display: flex;
        width: 46%;
        //width: 1024px;
        //padding-left: 32px;
      }
    }
    .card-item-inner {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .card-content {
        flex: 1;
        display: flex;
        flex-direction: row;
        padding-top: 2px;
        margin: -1px 1px 1px;
        background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
        border-radius: 4px;
        border: 1px solid;
        border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
        border-top: none;
        .left {
          width: 27%;
          //width: 1024px;
          //padding-left: 32px;
        }
        .right {
          width: 27%;
          //width: 1024px;
          //padding-left: 32px;
        }
        .center {
          width: 46%;
          //width: 1024px;
          //padding-left: 32px;
        }
      }

    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
          180deg,
          rgba(189, 232, 247, 1) 0%,
          rgba(191, 229, 252, 1) 20%,
          rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
      .chart-con {
        .chart-box {
          // width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // padding: 0 20px;
          .bar-box {
            position: relative;
            width: 28px;
            height: 100%;
            padding: 0 8.3%;
            &:after {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              width: 68px;
              height: 76px;
              content: '';
              background: url('~img/market/bar-bottom.png') center center no-repeat;
              background-size: cover;
            }
            &.bar0:after {
              background: url('~img/market/bar-bottom1.png') center center no-repeat;
              background-size: cover;
            }
            &.bar1:after {
              background: url('~img/market/bar-bottom2.png') center center no-repeat;
              background-size: cover;
            }
            &.bar2:after {
              background: url('~img/market/bar-bottom3.png') center center no-repeat;
              background-size: cover;
            }
          }
          .city-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .num {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 14px;
              color: #ffffff;
              white-space: nowrap;
              &.city-0 {
                background: linear-gradient(0deg, #f63d01 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-1 {
                background: linear-gradient(0deg, #f48f00 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-2 {
                background: linear-gradient(0deg, #82f40e 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .name {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #fdffff;
              white-space: nowrap;
            }
          }
          .bar-bg {
            width: 20px;
            height: 144px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            .bf {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              box-sizing: border-box;
              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, rgba(2, 26, 28, 0), rgba(24, 72, 117, 0.96));
              }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, rgba(24, 72, 117, 1), rgba(4, 61, 66, 0.3));
              }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: rgba(24, 72, 117, 0.6);
              }
            }
          }
          .cube {
            width: 20px;
            height: 100px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            z-index: 9;
            // animation: rotate 5s infinite linear;
            .face {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              // border: 2px solid #ccc;
              box-sizing: border-box;

              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, #1960b6, #3988ff);
              }
              // .back {
              //   transform: rotateY(180deg) translateZ(10px);
              //   background: linear-gradient(to right, #45a29e, #66bfa6);
              // }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, #072975, #1748c1);
              }
              // .left {
              //   transform: rotateY(-90deg) translateZ(10px);
              //   background: linear-gradient(to top, #ff6f61, #ffcc5c);
              // }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: #5dc9ff;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
              // .bottom {
              //   transform: rotateX(-90deg) translateZ(10px);
              //   background: linear-gradient(to left, #66bfa6, #45a29e);
              // }
            }
            &.cube-0 {
              .front {
                background: linear-gradient(to top, #d1602b, #ffaf83);
              }
              .right {
                background: linear-gradient(to bottom, #b1440e, #742111);
              }
              .top {
                background: #ff7c3a;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
            }
            &.cube-1 {
              .front {
                background: linear-gradient(to top, #ffc76e, #ffe6bf);
              }
              .right {
                background: linear-gradient(to bottom, #ac670d, #fed423);
              }
              .top {
                background: #ffcd7e;
              }
            }
            &.cube-2 {
              .front {
                background: linear-gradient(to top, #19a6b0, #00c67e);
              }
              .right {
                background: linear-gradient(to bottom, #07646a, #01b575);
              }
              .top {
                background: #60f9cc;
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    padding-top: 13px;
    padding-bottom: 15px;
    .info-box{
      position: relative;
      width: 248px;
      height: 228px;
      padding: 10px 0;
      padding-left: 10px;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      //align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .info-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .text-padding-left {
        padding-left: 10px;
      }
      .info-flex{
        display: flex;
        .left{
          width: calc(100%/5*2);
        }
        .right{
          width: calc(100%/5*3);
          padding-right: 6px;
        }
        .person-img {
          width: 90px;
          height: 120px;
        }
      }
      .a-class {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 14px;
        color: rgba(129, 204, 250, 0.8);
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 16px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin-top: 15px;
      }
      .sum-h2 {
        margin-right: 8px;
        font-family: YouSheTitle;
        font-weight: 400;
        font-size: 16px;
        color: #e4edf7;
      }
    }
    .sum-box {
      position: relative;
      width: 248px;
      height: 218px;
      padding: 28px 0;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      //align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .person-img {
        width: 100px;
        height: 87px;
        background-size: 100% 100%;
      }
      .sum-img {
        width: 100px;
        height: 87px;
        background: url('~img/market/market-l-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 18px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin: 10px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      max-height: 218px;
      overflow-y: scroll;
      .list-item {
        + .list-item {
          margin-top: 18px;
        }
        .item-top {
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 16px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 18px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 3px;
              margin-right: 4px;
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: -1px;
              width: 80%;
              height: 6px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -2px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    height: calc(100% / 3 * 2);
    .list-box {
      width: 100%;
      height: 253px;
      padding: 17px 0 8px;
      overflow-y: scroll;
      .list-item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
        .item-l {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          b {
            width: 26px;
            text-align: center;
            font-family: Geometr706 BlkCn BT;
            font-weight: 900;
            font-size: 22px;
            color: #00c9ff;
            font-style: italic;
            background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 22px;
          }
        }
        .item-c {
          height: 20px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #fcf5c2;
          line-height: 20px;
        }
        .item-r {
          width: 80px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            width: 12px;
            height: 12px;
            line-height: 12px;
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
            white-space: nowrap;
          }
          &.trend1 {
            background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-up.png') center center no-repeat;
              background-size: cover;
            }
          }
          &.trend2 {
            background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-down.png') center center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 0px 10px;
    font-size: 18px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 5px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    flex: 1;
    height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
  /deep/ .ele-dialog {
    z-index: 9999;
    &.info-modal {
      z-index: 999;
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
  }
}





//原型ui

.group_10 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 580px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-left: 34px;
  width: 1022px;
  position: relative;
  justify-content: flex-center;
}
.box_12 {
  width: 994px;
  height: 34px;
  margin: 16px 0 0 14px;
}
.block_6 {
  position: relative;
  width: 236px;
  height: 25px;
  margin-top: 6px;
}
.image-wrapper_1 {
  height: 18px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/370bfd09e529c5d8e2cbdcb06e3e703c)
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 7px;
  width: 236px;
}
.thumbnail_4 {
  width: 16px;
  height: 20px;
  margin: -7px 0 0 17px;
}
.text_94 {
  position: absolute;
  left: 45px;
  top: 0;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
}
.block_7 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 100px;
  height: 24px;
  margin-left: 118px;
}
.text_95 {
  width: 35px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 6px 0 0 10px;
}
.thumbnail_5 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 37px;
}
.block_8 {
  width: 177px;
  height: 21px;
  margin: 4px 0 0 10px;
}
.group_11 {
  width: 122px;
  height: 16px;
}
.thumbnail_6 {
  width: 16px;
  height: 16px;
}
.text_96 {
  width: 95px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(160, 220, 236, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin-top: 2px;
}
.group_12 {
  background-image: linear-gradient(
      90deg,
      rgba(38, 76, 152, 1) 0,
      rgba(38, 76, 152, 1) 0.585938%,
      rgba(38, 76, 152, 0.729412) 12.011719%,
      rgba(92, 182, 255, 1) 48.217773%,
      rgba(92, 182, 255, 1) 48.632812%,
      rgba(92, 182, 255, 0.709804) 89.18457%,
      rgba(38, 76, 152, 1) 99.316406%,
      rgba(38, 76, 152, 1) 99.414062%
  );
  width: 177px;
  height: 2px;
  margin-top: 3px;
}
.block_9 {
  width: 216px;
  height: 28px;
  margin: 6px 0 0 137px;
}
.block_10 {
  width: 125px;
  height: 24px;
  margin-left: 20px;
}
.label_4 {
  width: 22px;
  height: 24px;
}
.text_97 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin-top: 3px;
}
.image_9 {
  width: 216px;
  height: 18px;
  margin-top: -14px;
}
.box_13 {
  width: 991px;
  height: 508px;
  margin: 6px 0 16px 14px;
}
.group_13 {
  position: relative;
  width: 236px;
  height: 508px;
}
.block_11 {
  height: 220px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ab8bf6a51ea79e79dd20b824f1eaaaaf)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 218px;
}
.group_14 {
  width: 193px;
  height: 102px;
  margin: 15px 0 0 14px;
}
.box_14 {
  background-color: rgba(248, 250, 253, 1);
  width: 75px;
  height: 100px;
}
.text-wrapper_18 {
  width: 34px;
  height: 44px;
  margin: 58px 0 0 12px;
}
.text_98 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}
.text_99 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 16px;
}
.text-wrapper_19 {
  width: 66px;
  height: 102px;
  margin-left: 6px;
}
.text_100 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 32px;
}
.text_101 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 44px;
}
.text_102 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 17px;
}
.text-wrapper_20 {
  width: 168px;
  height: 15px;
  margin: 18px 0 0 14px;
}
.text_103 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 1px;
}
.text_104 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_105 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 20px;
}
.text_106 {
  width: 41px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 6px;
}
.text-wrapper_21 {
  width: 189px;
  height: 15px;
  margin: 19px 0 36px 14px;
}
.text_107 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}
.text_108 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_109 {
  width: 69px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 36px;
}
.text_110 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.image-wrapper_2 {
  height: 18px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/406e15b6edf85de763443a6685d60c13)
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 31px;
  width: 236px;
}
.image_10 {
  width: 20px;
  height: 22px;
  margin: -10px 0 0 18px;
}
.block_12 {
  width: 218px;
  height: 230px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/b29f7c29efeab77e4d7a14ea53d1c38f)
  100% no-repeat;
  background-size: 100% 100%;
  margin: 9px 0 0 5px;
}
.text_111 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 15px 0 0 173px;
}
.text_112 {
  width: 59px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 9px 0 0 14px;
}
.text_113 {
  width: 179px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(246, 248, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 4px 0 0 13px;
}
.text_114 {
  width: 58px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 13px 0 0 14px;
}
.text_115 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 4px 0 0 14px;
}
.text_116 {
  width: 57px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 14px 0 0 15px;
}
.text_117 {
  width: 178px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 6px 0 0 13px;
}
.text-group_1 {
  width: 88px;
  height: 32px;
  margin: 13px 0 24px 13px;
}
.text_118 {
  width: 87px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 1px;
}
.text_119 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(96, 249, 204, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 4px;
}
.text_120 {
  position: absolute;
  left: 45px;
  top: 244px;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
}
.group_15 {
  position: relative;
  width: 514px;
  height: 496px;
  margin: 12px 0 0 23px;
}
.box_15 {
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/c695b17e44715f380a734fef2cf8bea0)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 189px;
  width: 325px;
  position: relative;
}
.text_121 {
  width: 141px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 17px 0 0 102px;
}
.image-wrapper_3 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/98cbb47a25c3decac5893c31c77f4070) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -172px;
  top: 4px;
}
.image_11 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.box_16 {
  position: relative;
  width: 102px;
  height: 105px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/f26217fe72674c95946b120e71da26c3) -2px -4px
  no-repeat;
  background-size: 112px 112px;
  margin: 4px 0 0 176px;
}
.text-wrapper_22 {
  position: absolute;
  left: 58px;
  top: 74px;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/8e54b993c89c68637faee1525815804c)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_122 {
  width: 189px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 9px 0 0 59px;
}
.text_123 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 12px 105px;
}
.text-wrapper_23 {
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/3e6bfe97ec936efaf96c173ee9cd7d34)
  100% no-repeat;
  background-size: 100% 100%;
  width: 325px;
  position: absolute;
  left: 58px;
  top: 10px;
}
.text_124 {
  width: 141px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 18px 0 0 102px;
}
.image-wrapper_4 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/6fc98db83c655fe25bfc5aee89bd2981) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -194px;
  top: 14px;
}
.image_12 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_5 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/15de920bb5fa84639f66d37587ab182c) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -194px;
  top: 77px;
}
.image_13 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_6 {
  width: 496px;
  height: 18px;
  margin-top: 114px;
}
.image_14 {
  width: 236px;
  height: 18px;
}
.image_15 {
  width: 236px;
  height: 18px;
}
.box_17 {
  width: 478px;
  height: 198px;
  margin: 9px 0 0 5px;
}
.box_18 {
  width: 218px;
  height: 198px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/d90a9ab56a7dd6c9c3df0e8f0c0d58ed)
  100% no-repeat;
  background-size: 100% 100%;
}
.box_19 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 30px;
  margin-top: 13px;
  width: 217px;
}
.box_20 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.section_9 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_10 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_11 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_24 {
  width: 108px;
  height: 13px;
  margin: 3px 0 9px 54px;
}
.text_125 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 108px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_21 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 30px;
  margin-top: 9px;
  width: 217px;
}
.section_12 {
  width: 34px;
  height: 4px;
}
.group_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_25 {
  width: 96px;
  height: 13px;
  margin: 3px 0 10px 60px;
}
.text_126 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_22 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 30px;
  margin-top: 9px;
  width: 217px;
}
.group_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.section_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_26 {
  width: 96px;
  height: 13px;
  margin: 3px 0 9px 60px;
}
.text_127 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_23 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 30px;
  width: 217px;
  margin: 9px 0 38px 0;
}
.group_20 {
  width: 34px;
  height: 4px;
}
.section_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_27 {
  width: 143px;
  height: 12px;
  margin: 5px 0 9px 37px;
}
.text_128 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 143px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_24 {
  width: 218px;
  height: 198px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/50ba2ee5e2451916d291ce28a04ad98d)
  100% no-repeat;
  background-size: 100% 100%;
}
.box_25 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 46px;
  margin-top: 13px;
  width: 217px;
}
.section_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.box_26 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_27 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_28 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_28 {
  width: 193px;
  height: 27px;
  margin: 5px 0 9px 14px;
}
.paragraph_2 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 193px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
}
.box_29 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.box_30 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.block_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.block_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.block_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_29 {
  width: 180px;
  height: 13px;
  margin: 3px 0 8px 18px;
}
.text_129 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 180px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_31 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.section_20 {
  width: 34px;
  height: 4px;
}
.group_21 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_22 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_23 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_30 {
  width: 163px;
  height: 13px;
  margin: 4px 0 8px 26px;
}
.text_130 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 163px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_32 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  width: 217px;
  margin: 9px 0 23px 0;
}
.group_24 {
  width: 34px;
  height: 4px;
}
.box_33 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_34 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_35 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_31 {
  width: 150px;
  height: 12px;
  margin: 5px 0 8px 34px;
}
.text_131 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 150px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_36 {
  position: absolute;
  left: 18px;
  top: 260px;
  width: 366px;
  height: 25px;
}
.label_5 {
  width: 22px;
  height: 24px;
  margin-top: 1px;
}
.text_132 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin: 4px 0 0 10px;
}
.label_6 {
  width: 27px;
  height: 24px;
  margin-left: 155px;
}
.text_133 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin: 4px 0 0 9px;
}
.group_25 {
  width: 208px;
  height: 505px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/99d8f2cf537e143367968988c95e8984)
  100% no-repeat;
  background-size: 100% 100%;
  margin: 3px 0 0 10px;
}
.box_37 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 7px 0 0 4px;
}
.text_134 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 82px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 55px;
}
.image_16 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_17 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_38 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_135 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 106px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 7px 0 0 47px;
}
.image_18 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_19 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_39 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_3 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 134px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 32px;
}
.image_20 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_21 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_40 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_4 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 122px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 8px 0 0 38px;
}
.image_22 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_23 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_41 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_5 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 101px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 49px;
}
.image_24 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_25 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_42 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_6 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 125px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_26 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_27 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_43 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_7 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 132px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 8px 0 0 33px;
}
.image_28 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_29 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_44 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_136 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 118px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 41px;
}
.image_30 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_31 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_45 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_8 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_32 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_33 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_46 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 8px 4px;
}
.text_137 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 40px;
}
.image_34 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_35 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_47 {
  position: absolute;
  left: 485px;
  top: 255px;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/426c1d36984ebed92a837393c2a411e0)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_138 {
  width: 142px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 108px;
}
.text_139 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 11px 131px;
}
.text-wrapper_32 {
  position: absolute;
  left: -278px;
  top: 0;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ea8f102e075ca88cf106e7c207ed5e2e)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_140 {
  width: 189px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 77px;
}
.text_141 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 11px 123px;
}
.text-wrapper_33 {
  position: absolute;
  left: 286px;
  top: 68px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/aaaa44abff14d677c108bf81808690fb)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_142 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_143 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_34 {
  position: absolute;
  left: 251px;
  top: 130px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/a605f2cf9d740583581ebbca6b9106a8)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_144 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_145 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_35 {
  position: absolute;
  left: 251px;
  top: 193px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/76c9b6163c7c219ce215221bd4b14ca2)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_146 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_147 {
  width: 94px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 3px 0 10px 47px;
}
</style>
